import { render, staticRenderFns } from "./ispPppList.vue?vue&type=template&id=79d95058&"
import script from "./ispPppList.vue?vue&type=script&lang=js&"
export * from "./ispPppList.vue?vue&type=script&lang=js&"
import style0 from "./ispPppList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports